// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type IsGreaterThanOrEqualTo from '../contract/IsGreaterThanOrEqualTo';

export default function isGreaterThanOrEqualTo(
    data: IsGreaterThanOrEqualTo
): IsGreaterThanOrEqualTo {
    const result: IsGreaterThanOrEqualTo = {
        __type: 'IsGreaterThanOrEqualTo:#Exchange',
        ...data,
    };

    return result;
}
